﻿import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Space, SpaceProps, Typography } from 'antd';
import { TextProps } from 'antd/lib/typography/Text';
import { observer } from 'mobx-react';
import React, { isValidElement, ReactElement, ReactNode } from 'react';

interface Props {
    label: ReactNode,
    icon: IconDefinition | ReactElement,
    spaceProps?: SpaceProps,
    textProps?: TextProps
}

const PanelHeader: React.FC<Props> = ({
    label,
    icon,
    spaceProps = {},
    textProps = {}
}) => {

    const {
        style: textStyle,
        ...textRestProps
    } = textProps;       

    return (
        <Space align='baseline' {...spaceProps}>
            {
                isValidElement(icon) ? icon : <FontAwesomeIcon icon={icon} style={{ fontSize: 16 }} fixedWidth />
            }
            <Typography.Text strong {...textRestProps} style={{ fontSize: 14, ...textStyle }}>
                {label}
            </Typography.Text>
        </Space>
    )
}     

export default observer(PanelHeader);